import { AlertCircle, CheckCircle } from "lucide-react";
import styles from "./ProductStatusBadge.module.scss";

export type ProductStatus = "in-stock" | "low-stock" | "out-of-stock";

interface ProductStatusBadgeProps {
  status: ProductStatus;
}

export const getProductStatus = (unitsAvailable: number): ProductStatus => {
  if (unitsAvailable === 0) return "out-of-stock";
  if (unitsAvailable < 10) return "low-stock";
  return "in-stock";
};

export const ProductStatusBadge = ({ status }: ProductStatusBadgeProps) => {
  const getBadgeContent = () => {
    switch (status) {
      case "in-stock":
        return {
          className: styles.badgeSuccess,
          icon: <CheckCircle className={styles.badgeIcon} />,
          label: "En Stock",
        };
      case "low-stock":
        return {
          className: styles.badgeWarning,
          icon: <AlertCircle className={styles.badgeIcon} />,
          label: "Stock Bajo",
        };
      case "out-of-stock":
        return {
          className: styles.badgeDanger,
          icon: <AlertCircle className={styles.badgeIcon} />,
          label: "Agotado",
        };
    }
  };

  const { className, icon, label } = getBadgeContent();

  return (
    <span className={`${styles.badge} ${className}`}>
      {icon}
      {label}
    </span>
  );
};
